// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"88a51963","839":"6f5fa6e9"}[chunkId] + ".chunk.js";
};